import { registerFabricClass, resolveFromObject } from '../utils';
import Link, { LinkObject } from './Link';
import { NodeObject } from './Node';
import { PortObject } from './Port';

class CurvedLink extends Link {
	static type = 'curvedLink';
	superType = 'link';

	constructor(
		fromNode: Partial<NodeObject>,
		fromPort: Partial<PortObject>,
		toNode: Partial<NodeObject>,
		toPort: Partial<PortObject>,
		options: Partial<LinkObject> = {},
	) {
		super(fromNode, fromPort, toNode, toPort, options);
	}

	_render(ctx: CanvasRenderingContext2D) {
		// Drawing curved link
		const { x1, y1, x2, y2 } = this as any;
		const stroke = typeof this.stroke === 'string' ? this.stroke : '#000';
		ctx.lineWidth = this.strokeWidth;
		ctx.strokeStyle = stroke;
		const fp = { x: (x1 - x2) / 2, y: (y1 - y2) / 2 };
		const sp = { x: (x2 - x1) / 2, y: (y2 - y1) / 2 };
		ctx.beginPath();
		ctx.moveTo(fp.x, fp.y);
		ctx.bezierCurveTo(fp.x, sp.y, sp.x, fp.y, sp.x, sp.y);
		ctx.stroke();
		ctx.save();
		if (this.fromNode.descriptor?.outPortType === 'STATIC' || this.fromNode.outPortType === 'STATIC') {
			ctx.font = '12px flomon-icon';
			ctx.fillStyle = this.fromNode.fromPort.filter(
				(port: PortObject) => port.id === this.fromPort.id,
			)[0].originFill;
			ctx.fillText(this.fromPort.id.toUpperCase(), (fp.x + sp.x) / 2 + 10, (fp.y + sp.y) / 2 - 10);
		}
		const xDiff = x2 - x1;
		const yDiff = y2 - y1;
		const angle = Math.atan2(yDiff, xDiff);
		ctx.translate((x2 - x1) / 2, (y2 - y1) / 2);
		ctx.rotate(angle >= 0 ? 1.57 : -1.57);
		ctx.beginPath();
		if (this.arrow) {
			// Move 5px in front of line to start the arrow so it does not have the square line end showing in front (0,0)
			ctx.moveTo(5, 0);
			ctx.lineTo(-5, 5);
			ctx.lineTo(-5, -5);
		}
		ctx.closePath();
		ctx.fillStyle = stroke;
		ctx.fill();
		ctx.restore();
	}

	static fromObject(options: any, callback?: any) {
		return resolveFromObject(
			new CurvedLink(options.fromNode, options.fromPort, options.toNode, options.toPort, options),
			callback,
		);
	}
}

registerFabricClass('CurvedLink', CurvedLink);

export default CurvedLink;
